export const TEAM_TYPES = ["mdc", "regulatory"]
export const PRACTICE_TEAM_TYPES = ["managers", "clinical", "site", "unblinded"]
